<div class="container-fluid featureCss">
    <div class="row footer-sub-container">
        <div class="col-lg-12 col-xl-12" [ngClass]="{'links-landing': profileOption, 'links': !profileOption}">
            <a href="https://www.signify.com/global/contact" target="_blank"  rel="noopener" class="footer adding-links">Contact Signify </a>
            <span class="footer">|</span>
            <a href="https://www.signify.com" target="_blank"  rel="noopener" class="footer adding-links">Signify</a>
            <span class="footer">|</span>
            <a href="https://www.signify.com/global/privacy/legal-information/cookies-notice" target="_blank"  rel="noopener" class="footer adding-links">Cookie notice </a>
            <span class="footer">|</span>
            <a href="https://www.signify.com/global/legal/privacy/legal-information/privacy-notice" target="_blank"  rel="noopener" class="footer adding-links">Privacy notice </a>
            <span class="footer">|</span>
            <a href="https://www.signify.com/global/vulnerability-disclosure" target="_blank"  rel="noopener" class="footer adding-links">Product security </a>
            <span class="footer">|</span>
            <a href="https://www.signify.com/global/terms-of-use" target="_blank"  rel="noopener" class="footer adding-links">Terms of use</a>
            <span class="footer">|</span>
            <a href="/about" target="_blank"  rel="noopener" class="footer adding-links">About</a>
        </div>
    </div>
    <div class="row footer-bottom-row">
        <div class="col-xl-4"></div>
        <div class="col-xl-4 reserved" [ngClass]="{'loginFooter': profileOption, 'otherFooter': !profileOption}">
            <i class="fa fa-copyright fa-xs" aria-hidden="true"> </i>
            © {{copyRightYear}} Signify Holding. All rights reserved.
        </div>
        <div class="col-xl-4 version-info">
            <span class="app-version">{{ appVersion }}</span>
        </div>
    </div>
</div>
